module.exports = __webpack_public_path__ + "static/sca_exemptions3-78238c641dfb05b2c25692f2881b12eb.png";